import { render, staticRenderFns } from "./FamilyLawManualStep.vue?vue&type=template&id=d77e57b0"
import script from "./FamilyLawManualStep.vue?vue&type=script&lang=ts"
export * from "./FamilyLawManualStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports